import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import HybridBasicLayout from '../../layout/basic/hybrid.basic.layout.vue';
import GoBackArrow from '../../shared/GoBackArrow/go.back.arrow.vue';
import HybridButtonTwo from '../../shared/HybridButtonTwo/hybrid.button.two.vue';
import HybridFormFieldTextinput from '../../shared/HybridFormFieldTextinput/hybrid.form.field.textinput.vue';
import Dialogue from '../../../shared/Dialogue/dialogue.vue';
import * as T_T from 'cryface';
import { HybridServicesAppointmentValidator } from './validator';
import { EpicContextService } from '../../../services/EpicContextService/epic.context';
import { CommonConfig } from '../../../configs/config.common';
import { AxiosPromise } from '../../../utils/axios.promise';
import { CallNative } from '../../../services/EpicContextService/call.native';
import { NoticeConfig } from 'iview';

@Component(
    {
        components: {
            'layout': HybridBasicLayout,
            Dialogue,
            GoBackArrow,
            HybridButtonTwo,
            HybridFormFieldTextinput,
        }
    }
)
export default class HybridServicesAppointment extends Vue {
    public data: string = '';

    public clientName: string = 'Client Name';

    public epicContext = EpicContextService.instance();

    public configs = new CommonConfig();

    public phone: string = '';

    public phoneBuffer: string = '';

    public submitActive = false;

    public errorMessage: string = '';

    public dialogueShow = false;

    public fjjUserId = null;

    public codeVarify = '';

    public codeToVarify = '';

    public codeVarifyReset = '重新发送';

    public codeVarifying = false;

    public codeVarifyTaskID: any;

    public notify: string = `点击确认收取短信验证码，\r\n并修改预留电话号码，\r\n注意：该操作将会修改用户账户中的电话信息。`;

    public userInfo = {
        uName: '',
        uGender: '',
        uPhone: '',
        uEmail: '',
        uImg: '',
        countryType: 38,
        partnerId: -1,
        zone_code: '',
    };

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    @Watch('phone', { immediate: true, deep: true })
    public onPhoneInput(val: any, oldVal: any) {
        if (val.length > 0 && this.userInfo.partnerId) {
            // if (val.length > 0 && this.clientName.length > 0) {
            this.submitActive = true;
        } else {
            this.submitActive = false;
        }
    }

    @Watch('globalPudge', { immediate: true, deep: true })
    public async onEpicContext(globalPudge: any, globalPudgeOld: any) {
        const fjjUserId = globalPudge.getParam('fjjUserId');
        if (fjjUserId) {
            this.fjjUserId = fjjUserId;
            await this.getUserInfo();

        }
    }

    public created() {
        CallNative.setNativeNavTitle('预约', 'Appointment');
    }

    public mounted() {
        this.notify = this.$t('31') as string;
        this.codeVarifyReset = this.$t('39') as string;
        // const couponId = this.$route.params['couponId'];
        // console.log(couponId, 'couponId');
    }

    public async confirm() {
        if (this.submitActive) {
            const form = {
                clientName: this.clientName,
                phone: this.phone,
            };
            this.errorMessage = HybridServicesAppointmentValidator.validator(form);
            if (this.errorMessage === 'validated') {
                if (this.phone.replace('+', '') !== this.phoneBuffer.replace('+', '')) {
                    if (!this.codeVarifying) {
                        this.dialogueShow = true;
                    } else {
                        if (this.codeVarify === this.codeToVarify) {
                            await this.postChangePhone();
                            await this.postAppointment();
                            this.$router.push('/hybrid/services/appointment/success');
                        } else {
                            alert(this.$t('32'));
                        }
                    }
                } else {
                    await this.postAppointment();
                }
            } else {
                alert(this.errorMessage);
            }
        }
    }

    public async postChangePhone() {
        this.userInfo.uPhone = this.phone;
        const apiHost = this.configs.cmisapiHost;
        const fetched = await AxiosPromise.postJson(`${apiHost}/ac/personalInfo`, {
            userid: this.fjjUserId,
            vCode: this.codeVarify,
            ltype: 1,
            personalInfo: {
                uPhone: this.userInfo.uPhone,
                uName: this.userInfo.uName,
                uGender: this.userInfo.uGender,
                uEmail: this.userInfo.uEmail,
                uImg: this.userInfo.uImg,
                countryType: this.userInfo.countryType,
                zone_code: this.userInfo.zone_code,
            },
        });
    }

    public async postAppointment() {
        const insId = this.$route.params.insId;
        const apiHost = this.configs.couponService;
        const body = {
            instid: insId,
            partnerid: this.userInfo.partnerId,
            uname: this.clientName,
            phone: this.phone,
        };
        try {
            const fetched = await AxiosPromise.postUrlEncode(`${apiHost}/coupon/instance/using`, body);
            if (fetched.status === 200) {
                if (fetched.data.errorCode === 200) {
                    const noticeTitle = this.$t('33');
                    const noticeConfit: NoticeConfig = {
                        title: noticeTitle as string,
                        desc: this.$t('34') as string,
                    };
                    this.$Notice.success(noticeConfit);
                    await T_T.delay(2000);
                    CallNative.runNativeFun('nativeGoOrder');
                } else {
                    const noticeConfit: NoticeConfig = {
                        title: 'Appointment Failed',
                        desc: fetched.errorMsg
                    };
                    this.$Notice.error(noticeConfit);
                    await T_T.delay(2000);
                    CallNative.runNativeFun('nativeClose');
                }
            }
        } catch (e) {
            console.error(e);
        }
    }

    public async dialogueOK() {
        const fetched = await this.getCodeVarify();
        if (fetched.status === 200) {
            const data = fetched.data;
            if (data.code === 401) {
                this.dialogueShow = false;
                alert(this.$t('37'));
            } else if (data.code === 200) {
                this.codeToVarify = data.data;
                this.dialogueShow = false;
            } else {
                // alert(`手机号已被注册，请核实，客服电话：(416) 883-9666`);
            }
        }
    }

    public closeDialogue() {
        this.dialogueShow = false;
    }

    public formatPhone(str: string) {
        if (str.trim().length === 10 && str.indexOf('+1') < 0) {
            return `+1${str}`;
        }
        if (str.trim().length === 11 && str.indexOf('+1') < 0) {
            return `+${str}`;
        }
        return str;
    }

    public async getUserInfo() {
        const apiHost = this.configs.cmisapiHost;
        // window.epicFunctions.setParam('fjjUserId', 195);
        const body = {
            uid: this.fjjUserId,
            ltype: 1,
        };
        const fetched = await AxiosPromise.postJson(`${apiHost}/login/uid`, body);
        if (fetched.status === 200) {
            if (fetched.data.code === 200) {
                const data = fetched.data.data;
                this.userInfo.countryType = T_T.simpleDetect(data.countryid) ? data.countryid : 38;
                this.userInfo.uEmail = data.uEmail;
                this.userInfo.uGender = data.uGender;
                this.userInfo.uImg = data.uImg;
                this.userInfo.uName = T_T.simpleDetect(data.uName) ? data.uName : '';
                this.userInfo.uPhone = T_T.simpleDetect(data.uPhone) ? this.formatPhone(data.uPhone) : '';
                this.userInfo.zone_code = data.zone_code;
                this.userInfo.partnerId = data.resPartnerId;
                this.phone = T_T.simpleDetect(this.userInfo.uPhone) ? this.formatPhone(this.userInfo.uPhone) : '';
                this.phoneBuffer = T_T.simpleDetect(this.userInfo.uPhone) ? this.formatPhone(this.userInfo.uPhone) : '';
                this.clientName = this.userInfo.uName;
                const _phoneInput: any = this.$refs.phoneInput;
                _phoneInput.inputEmit(this.phone);
            }
        }
    }

    public async resetCodeVarify() {
        if (!this.codeVarifying) {
            const fetched = await this.getCodeVarify();
            if (fetched.status === 200) {
                const data = fetched.data;
                if (data.code === 401) {
                    alert(this.$t('37'));
                } else if (data.code === 200) {
                    this.codeToVarify = data.data;
                } else {
                    // alert(`手机号已被注册，请核实，客服电话：(416) 883-9666`);
                }
            }
        }
    }

    public async getCodeVarify() {
        const apiHost = this.configs.cmisapiHost;
        const body = {
            phone: this.phone.replace('+1', ''),
            phoneSendMes: this.phone.replace('+1', ''),
            type: 1,
            ltype: 1,
            countryType: 38,
        };
        const fetched = await AxiosPromise.postJson(`${apiHost}/login/sendMobileCode`, body);
        this.codeVarifyStart();
        return fetched;
    }

    public codeVarifyStart() {
        let countdown = 120;
        this.codeVarifying = true;
        this.codeVarifyTaskID = setInterval(() => {
            this.codeVarifyReset = `${this.$t('38')}(${countdown})`;
            countdown = countdown - 1;
            if (countdown === 0) {
                clearInterval(this.codeVarifyTaskID);
                this.codeVarifyReset = this.$t('39') as string;
                this.codeVarifying = false;
            }
        }, 1000);
        return;
    }

}
